// src/components/CreateAccount.js

import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import {
  doc,
  setDoc,
  collection,
  getDocs,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import "../styles/createAccount.css";

function Txtaccount() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "employee",
    company: "Sarathchandra Textile", // Default company
  });

  const [showPassword, setShowPassword] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      // Query only by company to avoid needing composite index
      const q = query(
        collection(db, "users"),
        where("company", "==", "Sarathchandra Textile")
      );
      const snapshot = await getDocs(q);
      const userList = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        // Filter in memory: only non-disabled users with employee or security role
        .filter((user) => 
          user.disabled !== true && 
          (user.role === "employee" || user.role === "security")
        );

      setUsers(userList);
    };

    fetchUsers();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCreateAccount = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        name: formData.name,
        email: formData.email,
        role: formData.role,
        company: "Sarathchandra Textile", // Always set company
        disabled: false,
      });

      alert(
        `${formData.role.charAt(0).toUpperCase() + formData.role.slice(1)} account created successfully!`
      );
      setFormData({
        name: "",
        email: "",
        password: "",
        role: "employee",
        company: "Sarathchandra Textile",
      });

      // Re-fetch filtered users
      const q = query(
        collection(db, "users"),
        where("company", "==", "Sarathchandra Textile")
      );
      const snapshot = await getDocs(q);
      const userList = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((user) => 
          user.disabled !== true && 
          (user.role === "employee" || user.role === "security")
        );

      setUsers(userList);
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  const handleRename = async (id, newName) => {
    await updateDoc(doc(db, "users", id), { name: newName });
    setUsers(
      users.map((user) => (user.id === id ? { ...user, name: newName } : user))
    );
  };

  const handleResetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
      alert(`Password reset link sent to ${email}`);
    } catch (error) {
      alert(`Failed to send reset email: ${error.message}`);
    }
  };

  return (
    <div className="create-account-container">
      <h2>Create Account - Sarathchandra Textile</h2>
      <form onSubmit={handleCreateAccount} className="create-account-form">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          autoComplete="off"
        />

        <input
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
          autoComplete="new-password"
        />

        <label className="show-password-toggle">
          <input
            type="checkbox"
            checked={showPassword}
            onChange={() => setShowPassword((prev) => !prev)}
          />
          Show Password
        </label>

        <select name="role" value={formData.role} onChange={handleChange}>
          <option value="employee">User</option>
          <option value="security">Security</option>
        </select>

        <button type="submit">Create Account</button>
      </form>

      <h3>Manage Accounts - Sarathchandra Textile</h3>
      <table className="account-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No users found for Sarathchandra Textile
              </td>
            </tr>
          ) : (
            users.map((user) => (
              <tr key={user.id}>
                <td data-label="Name">
                  <input
                    type="text"
                    value={user.name}
                    onChange={(e) => handleRename(user.id, e.target.value)}
                  />
                </td>
                <td data-label="Email">{user.email}</td>
                <td data-label="Role">{user.role}</td>
                <td data-label="Actions">
                  <button onClick={() => handleResetPassword(user.email)}>
                    Reset Password
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Txtaccount;